import {
  allowedCfFieldTypesForIntegrationProperty,
  findIntegrationProperty,
  isUnsupportedIntegrationProperty,
} from "../../utils/integrationFieldTypeMap";

const useFieldTypeConstraint = (field, element, website) => {
  const property = findIntegrationProperty(website, field);
  const elementType = element && element.element_type;
  const rule = allowedCfFieldTypesForIntegrationProperty(property, elementType);
  const unsupported = property ? isUnsupportedIntegrationProperty(property) : false;
  const surveyIncompatible =
    elementType === "survey" && rule && rule.default && !unsupported;

  const propertyType = (property && property.type) || "unknown";
  const service = field && field.service;

  const unsupportedWarning = unsupported
    ? `${service} field type "${propertyType}" is not supported for direct mapping in ConvertFlow.`
    : undefined;
  const surveyMismatchWarning = surveyIncompatible
    ? `${service} field type "${propertyType}" — survey can't capture ${rule.default} values`
    : undefined;

  return {
    property,
    rule,
    unsupported,
    surveyIncompatible,
    unsupportedWarning,
    surveyMismatchWarning,
    defaultType: rule && rule.default,
    allowed: rule && rule.allowed,
  };
};

export default useFieldTypeConstraint;
